import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { MaterialDeviceSummary } from "../../schemas";
import { Box } from "@mui/material";

export function ByDevice(props: {
  data: MaterialDeviceSummary[],
  colors: { [key: string]: string },
  sortOrder: string,
}) {

  const devices = Array.from(new Set(props.data.map(item => item.device_id)));
  const materials = props.data.map(item => ({ id: item.material_id, name: item.material_name }))
  const materialSet = materials.filter((material, idx) => materials.findIndex(m => m.id === material.id) === idx);

  const graphDataDict = props.data.reduce((dict, item) => {
    if (!(item.device_id in dict)) {
      dict[item.device_id] = {}
    }
    dict[item.device_id][item.material_id] = item.count

    return dict
  }, {} as { [key: string]: { [key: string]: number } })

  const graphData = graphDataDict && devices.map(device => {
    const counts = materialSet && Object.fromEntries(materialSet?.map(m => [m.id, (graphDataDict[device] || {})[m.id] || 0]));
    const total = Object.values(counts).reduce((sum, count) => sum + count, 0)
    return { device, total, ...counts }
  })

  switch (props.sortOrder) {
    case 'device':
      graphData.sort((a, b) => a.device.localeCompare(b.device))
      break;
    case 'count':
      graphData.sort((a, b) => -a.total + b.total) //desc
      break;
  }

  return (
    <ResponsiveContainer minHeight={devices.length * 20}>
      <BarChart data={graphData} layout="vertical">
        <CartesianGrid strokeDasharray="3 3" horizontal={false} />
        <XAxis type="number" />
        <YAxis type="category" dataKey="device" interval={0} />
        <Tooltip content={({ payload, label }) => {
          const rows = payload?.filter(row => !!row.value)
            .map((row, i) => (
              <tr key={i} style={{ color: row.color, padding: 0 }}>
                <td>{row.name}</td>
                <td>:</td>
                <td style={{ textAlign: 'right' }}>{row.value}</td>
              </tr>
            ));

          return (
            <Box style={{ backgroundColor: 'rgba(255, 255, 255, 0.7)', fontSize: 'small', padding: 4, border: '1px solid grey' }}>
              <div>{label}</div>
              {
                rows && rows.length > 0 ? (
                  <table >
                    <tbody>
                      {rows}
                    </tbody>
                  </table>
                )
                  : <div style={{ fontStyle: 'italic', color: '#808080' }}>(No Data)</div>
              }
            </Box>
          )
        }}
        />
        {materialSet && materialSet.map((m, i) =>
          <Bar
            key={m.id}
            dataKey={m.id}
            stackId="a"
            fill={props.colors[m.id]}
            name={materialSet.filter(n => n.id === m.id)[0].name}
          />)}
      </BarChart>
    </ResponsiveContainer>
  )
}
